import { Injectable } from '@angular/core';
import {AccountInfoService} from './account-info.service';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {

  private _authToken: string;

  constructor() { }

  get token(): string {
    if (this._authToken) {
      return this._authToken;
    } else {
      return '';
    }
  }

  setToken(token) {
    this._authToken = token;
  }
}
